<template>
  <v-row class="mx-0">
    <v-col cols="12" class="pa-0">
      <span class="d-block kbDarkBlueText--text pt-3"
            style="font-size: 20px">
        {{ $t('general.extraData') }}
      </span>
    </v-col>

    <v-col cols="12" class="px-0 pt-2">
      <template v-for="(item, index) in filteredAppCustomExtradatas">
        <v-checkbox color="kbDarkBlueText"
                    :key="index"
                    :label="item.name"
                    hide-details
                    v-model="selectedExtraData"
                    :value="item.name">
        </v-checkbox>
        <v-select     v-if="item.type === 'select' && selectedExtraData.includes(item.name)"
                      class="py-2"
                      hide-details
                      :items="item.options"
                      item-value="name"
                      item-text="name"
                      outlined
                      dense
                      :key="`checkbox-${index}`"
                      :value="extraDataValues[item.name]"
                      @change="changeExtraDataValue({ key: item.name, value: $event })"
        />
        <v-select     v-else-if="item.type === 'checkbox' && selectedExtraData.includes(item.name)"
                      class="py-2"
                      hide-details
                      :items="item.options"
                      item-value="name"
                      item-text="name"
                      :multiple="true"
                      outlined
                      dense
                      :key="`checkbox-${index}`"
                      :value="extraDataValues[item.name]"
                      @change="changeExtraDataValue({ key: item.name, value: $event })"
        />
        <v-text-field v-else-if="selectedExtraData.includes(item.name)"
                      class="py-2"
                      dense
                      hide-details
                      :key="`${index}-value`"
                      :label="item.name"
                      outlined
                      :value="extraDataValues[item.name]"
                      @change="changeExtraDataValue({ key: item.name, value: $event })"
        />

      </template>
    </v-col>
  </v-row>
</template>

<script>
import { mapState } from 'vuex'

export default {
  computed: {
    ...mapState({
      appCustomExtradatas: state => state.apps.appCustomExtradatas
    }),
    filteredAppCustomExtradatas () {
      return this.appCustomExtradatas.filter(item => item.visibleOnSearch)
    },
    selectedExtraData: {
      get () {
        return this.selectedExtraDataProp
      },
      set (value) {
        this.$emit('onSelectedExtraDataChange', value)
      }
    }
  },
  methods: {
    changeExtraDataValue ({ key, value }) {
      this.$emit('onExtraDataValueChange', { key, value })
    }
  },
  props: {
    extraDataLabels: {
      type: Array,
      default: () => []
    },
    extraDataValues: {
      type: Object,
      default: () => {}
    },
    selectedExtraDataProp: {
      type: Array,
      default: () => []
    }
  }
}
</script>
